var _Glyphicon;
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Button, Input, Glyphicon } from 'reaxl';

/**
 *  Filter Keyword Component
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterKeyword(props) {
  const [value, changeValue] = useState(props.values?.keywordPhrases || '');
  useEffect(() => {
    changeValue(value);
  }, [value]);
  const handleOptionChange = () => {
    // regex define symbol RIGHT SINGLE QUOTATION MARK and LEFT SINGLE QUOTATION MARK (typing on IOS device)
    // replace them by APOSTROPHE (common standard single quote)
    const specialSingleQuoteRegex = /[\u2018\u2019]/g;

    // Create stubbed event object
    props.onOptionChange({
      target: {
        type: 'text',
        value: value.replace(specialSingleQuoteRegex, "'")
      }
    }, props.filter || {});
  };
  const handleKeyPress = event => {
    if (event.key.toLowerCase() === 'enter') {
      handleOptionChange(event);
    }
  };
  const handleKeywordsChange = event => {
    changeValue(event.target.value);
  };
  const {
    className,
    filter = {},
    ...rest
  } = props;
  const rootClasses = clsx('accordion-panel-input padding-top-3', className);

  // Remove any non-DOM attributes from props
  delete rest.collapsed;
  delete rest.collapsedTitle;
  delete rest.filters;
  delete rest.filtersOrder;
  delete rest.onOptionChange;
  delete rest.onOptionsClear;
  delete rest.resultCount;
  delete rest.values;
  delete rest.errors;
  return /*#__PURE__*/_jsxs("div", {
    className: rootClasses,
    "data-cmp": "filterKeyword",
    ...rest,
    children: [/*#__PURE__*/_jsx("div", {
      className: "col-xs-9 col-md-8 col-lg-9 padding-left-0 padding-right-2",
      children: /*#__PURE__*/_jsx(Input, {
        maxLength: "30",
        name: filter.name,
        onChange: handleKeywordsChange,
        onKeyPress: handleKeyPress,
        placeholder: "Keyword",
        value: value
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-xs-3 col-md-4 col-lg-3 padding-horizontal-0",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: handleOptionChange,
        type: "submit",
        block: true,
        children: _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
          glyph: "search"
        }))
      })
    })]
  });
}
export default FilterKeyword;